export default __webpack_public_path__ + "static/media/SCDream-Heavy.64217e4d.otf";